'use client';

import { useEffect, useRef } from 'react';

export default function BackupAssessmentScrollHandler({ children }: { children: React.ReactNode }) {
  const assessmentSectionRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const container = assessmentSectionRef.current;
    if (!container) {
      return;
    }
    const handleRestartClick = (event: Event) => {
      const target = event.target as HTMLElement | null;
      if (!target) {
        return;
      }
      const button = target.closest('button');
      if (!button || !container.contains(button)) {
        return;
      }
      if (button.textContent?.toLowerCase().includes('restart assessment')) {
        const heading = container.querySelector('h2');
        if (heading) {
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
    container.addEventListener('click', handleRestartClick);
    return () => {
      container.removeEventListener('click', handleRestartClick);
    };
  }, []);

  return (
    <section className="mb-16" id="assessment" ref={assessmentSectionRef}>
      {children}
    </section>
  );
}
